import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full py-6 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center">
              <span className="text-2xl font-black text-gray-900">Pidemelo</span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              Sistema de gestión para restaurantes que revoluciona 
              la forma de operar tu negocio.
            </p>
          </div>

          {/* Product Links */}
          <div className="space-y-4">
            <h4 className="font-bold text-gray-900">Producto</h4>
            <div className="space-y-2">
              <button 
                onClick={() => document.getElementById('caracteristicas').scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-600 hover:text-orange-600 text-sm transition-colors"
              >
                Características
              </button>
              <button 
                onClick={() => document.getElementById('demo').scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-600 hover:text-orange-600 text-sm transition-colors"
              >
                Demo
              </button>
              <a 
                href="https://demo.pidemelo.mx/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-600 hover:text-orange-600 text-sm transition-colors"
              >
                Demo en Vivo
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div className="space-y-4">
            <h4 className="font-bold text-gray-900">Empresa</h4>
            <div className="space-y-2">
              <a 
                href="https://www.cubed.com.mx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-600 hover:text-orange-600 text-sm transition-colors"
              >
                Acerca de
              </a>
              <a
                href="https://www.cubed.com.mx/#contact"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-gray-600 hover:text-orange-600 text-sm transition-colors"
              >
                Contacto
              </a>
              <a
                href="https://www.cubed.com.mx/#contact"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-gray-600 hover:text-orange-600 text-sm transition-colors"
              >
                Soporte
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-200 pt-6">
          <div className="text-center space-y-2">
            <p className="text-sm text-gray-500">
              Copyright © 2025 Cubed Solutions S.A de C.V. Todos los derechos reservados.
            </p>
            <p className="text-xs text-gray-400">
              Powered by{' '}
              <a 
                href="https://www.cubed.com.mx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-orange-600 hover:text-orange-700 font-medium transition-colors duration-200 hover:underline"
              >
                Cubed Solutions
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
